// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyC2ZZNx6J3Y0idKYyDZwG5osb_vccclMU8",
  authDomain: "arthurconnects.com",
  projectId: "aia-app-a2161",
  storageBucket: "aia-app-a2161.firebasestorage.app",
  messagingSenderId: "1018191722483",
  appId: "1:1018191722483:web:37e3ee3c1c8788fa464486",
  measurementId: "G-S31HBFFG40"
};
//CONSTANTS
const applicantsCol = 'applicants'
const applicationsCol = 'applications'

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db =getFirestore(app)
const analytics = getAnalytics(app);
const auth = getAuth(app);
const googleProvider = new GoogleAuthProvider();

export{
  db,
  applicantsCol,
  applicationsCol,
  auth,
  googleProvider

}

